import { Collision } from '@dnd-kit/core';
import dayjs from 'dayjs';
import { SnackbarVariant } from '@eas/common-web';
import {
  CalendarDataSourceType,
  CalendarHandle,
} from '@modules/planner/calendar/calendar-types';
import { GPSPoint, WorkOrder } from '@models';
import { planSingleWorkOrder } from '../utils/plan-single-work-order';
import { prepareDto } from '../utils/prepare-dto';
import { dragEndUtils } from './drag-end-utils';
import { useValidateWorkOrder } from './validate';

type Props = {
  showSnackbar: (message: string, variant: SnackbarVariant) => void;
  workOrders: WorkOrder[];
  calendarRef: React.RefObject<CalendarHandle>;
  collision: Collision;
  nextWorkOrder?: WorkOrder;
  prevWorkOrder?: WorkOrder;
  unitStartingPoint: GPSPoint;
  calendarSource: CalendarDataSourceType;
  unitId: string;
  validate: ReturnType<typeof useValidateWorkOrder>['validate'];
};

export const handlePlanWorkOrder = async ({
  showSnackbar,
  workOrders,
  calendarRef,
  calendarSource,
  collision,
  nextWorkOrder,
  prevWorkOrder,
  unitStartingPoint,
  unitId,
  validate,
}: Props) => {
  const calendarStartDate = dayjs.unix(calendarRef.current?.currentDate ?? 0);
  const unitIndex = (calendarSource?.yAxis?.data ?? []).findIndex(
    (row) => row.id === unitId
  );

  const newWorkOrder = workOrders[0];
  const newWorkOrderDto = prepareDto({
    currentDate: calendarStartDate.unix(),
    collision,
    workOrder: workOrders[0],
    offset: 0,
  });

  if (!newWorkOrderDto) return false;

  const isMultiDay = dragEndUtils.getIsMultiday({
    workOrder: newWorkOrderDto,
    calendarStartDate: calendarStartDate.startOf('day').format('YYYY-MM-DD'),
    shifts: calendarSource?.yAxis?.data?.[unitIndex].shifts ?? [],
  });

  const result = await validate(newWorkOrderDto, isMultiDay);
  if (result.ok === false) return false;

  //////////////////////////////////

  const resp = await planSingleWorkOrder({
    prevWorkOrder,
    nextWorkOrder,
    newWorkOrder,
    newWorkOrderDto,
    unitStartingPoint,
    isMultiDay,
  });
  if (!resp?.ok) {
    showSnackbar(resp?.error, resp.snackbarVariant);
    return false;
  }
  return true;
};
